import { Route } from '@angular/router'
import { FeatureType } from '../enums'
import { RouteGuard } from './route-guard.service'

export class RouteUtil {
    public static Make(path: string, component: any, feature: FeatureType | FeatureType[] | null): Route {
        var route: Route = {
            path: path,
            component: component,
        }

        if (feature != null) {
            route.canActivate = [RouteGuard]
            route.data = {
                feature: feature,
            }
        }

        return route
    }
}
